import { PathologyCreateOrderWebRequest, PathologyProvider } from '@quromedical/models';
import { SelectOption } from 'components/types';
import { FetcherSearchOptions } from 'design-system';
import { useCallback } from 'react';
import { trpc } from 'trpc';

export type UsePathologyActions = {
  isMutationLoading: boolean;
  error: string | undefined;
  create: (input: PathologyCreateOrderWebRequest) => Promise<void>;
};

export const pathologyTestFetcher =
  (optionsInput?: { limit: number }) =>
  async (
    data?: FetcherSearchOptions
  ): Promise<SelectOption<{ code: string; description: string }>[]> => {
    const options = optionsInput ? optionsInput : { limit: 100 };
    const { limit } = options;

    const query = data?.query;
    const result = await trpc.client.patient.getPathologyTests.query({
      provider: PathologyProvider.lancet,
      query,
      limit,
    });

    const records = result.map(res => {
      const { code, description } = res;
      const display = `${code} - ${description}`;

      return {
        display,
        value: res.code,
        meta: res,
      };
    });

    return records;
  };

export const usePathologyActions = (): UsePathologyActions => {
  const {
    mutate: createMutation,
    isLoading: isCreateLoading,
    error: trpcError,
  } = trpc.context.patient.createPathologyOrder.useMutation();

  const error = trpcError && trpcError.message ? trpcError.message : undefined;

  const create = useCallback(
    async (input: PathologyCreateOrderWebRequest) => {
      createMutation(input);
    },
    [createMutation]
  );

  const isMutationLoading = isCreateLoading;

  return { isMutationLoading, create, error };
};
